import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import Carousel from "react-elastic-carousel";
import styles from './slider.module.css';

var Slider = function Slider(_ref) {
  var setting = _ref.setting,
      onItemSelect = _ref.onItemSelect,
      selectedItem = _ref.selectedItem;
  var breakPoints = [// from the breakpoint and up it will effect
  {
    width: 650,
    itemsToShow: 3
  }, {
    width: 768,
    itemsToShow: 4
  }, {
    width: 1000,
    itemsToShow: 5
  }, {
    width: 1300,
    itemsToShow: 6
  }];

  var handleClick = function handleClick(e, item) {
    onItemSelect(item);
  };

  return /*#__PURE__*/_jsx("div", {
    className: "home-slider position-relative ".concat(setting.className),
    children: /*#__PURE__*/_jsx("div", {
      className: "".concat(styles.container, " shadow"),
      children: /*#__PURE__*/_jsx(Carousel, {
        pagination: false,
        showArrows: true,
        breakPoints: breakPoints,
        children: setting.items && setting.items.map(function (item, index) {
          return /*#__PURE__*/_jsxs("div", {
            onClick: function onClick(e) {
              handleClick(e, item);
            },
            className: "".concat(styles.wrapper, " ").concat(selectedItem.Title === item.Title ? styles.selectedItem : ''),
            children: [/*#__PURE__*/_jsx("p", {
              children: item.Title
            }), /*#__PURE__*/_jsx("pre", {
              children: ': '
            }), /*#__PURE__*/_jsx("p", {
              children: item.Count
            }), /*#__PURE__*/_jsx("img", {
              className: "".concat(styles.icon),
              src: "/images/table/icon person blue.png"
            })]
          }, index);
        })
      })
    })
  });
};

export default Slider;